
webpack.register(
    'modules/right-rail/leaderboard-mini/leaderboard-mini',
    function() {
        return import('modules/right-rail/leaderboard-mini/leaderboard-mini');
    },
    true
);